import { useState, useEffect } from 'react';
import api from '../utils/axios';

const useTokenPrice = (symbol) => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchTokenPrice = async () => {
			try {
				setLoading(true);
				const response = await api.get(
					`/token-price`
				);
				setData(response.data);
			} catch (err) {
				setError('Failed to fetch token price');
			} finally {
				setLoading(false);
			}
		};

		fetchTokenPrice();
	}, [symbol]);

	return { data, loading, error };
};

export default useTokenPrice;
